import O1HD from "../../engines/gameEngine";
import utilsModel from "../../engines/libs/utilsModel";
import archeryGame from "./archeryGame";

const {ccclass, property} = cc._decorator;

@ccclass
export default class archeryLosePage extends cc.Component {

    archeryGame:archeryGame = null;

    bindGame(game:archeryGame){
        this.archeryGame = game;
    }

    onBtnExit(){
        let needSubCoin:number = O1HD.getServices().userSrv.getCoins() * 0.1;
        O1HD.getServices().userSrv.setCoins(-needSubCoin,true);
        this.archeryGame.closeThis();
        this.closeThis();
    }

    onBtnContinue(){
        utilsModel.loadAndShowVideoAdTrans(()=>{
            this.archeryGame.roleAlive();
            this.closeThis();
        },()=>{},null,"拯救华贵妃观看视频复活")
    }

    closeThis(){
        this.node.destroy();
    }

}
